import { render, staticRenderFns } from "./VideoUpload.vue?vue&type=template&id=a325611a&scoped=true&"
import script from "./VideoUpload.vue?vue&type=script&lang=js&"
export * from "./VideoUpload.vue?vue&type=script&lang=js&"
import style0 from "./VideoUpload.vue?vue&type=style&index=0&id=a325611a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a325611a",
  null
  
)

export default component.exports